/* eslint-disable */
/* this file generate by raw-icons/build.js */

import React from 'react';

const textHeader = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#8C8C8C"
      fillRule="evenodd"
      d="M30 28H18v11a1 1 0 01-1 1h-6a1 1 0 01-1-1V9a1 1 0 011-1h6a1 1 0 011 1v11h12V9a1 1 0 011-1h6a1 1 0 011 1v30a1 1 0 01-1 1h-6a1 1 0 01-1-1V28z"
    />
  </svg>
);

export default textHeader;
